/**
 * Bearers that must never be replayed as the staff user.
 *
 * The 401 recovery interceptor needs to recognise an impersonated request, but
 * it cannot import the session store (that would close an import cycle through
 * the api client). The session store records each bearer here when a session
 * opens; everything else reads.
 *
 * **Tokens are remembered after the session ends, deliberately.** A request
 * issued during a session can return its 401 after the actor has exited — if
 * exit erased the record, that late failure would look like an ordinary one and
 * be replayed with the staff token, executing a subject-scoped request with
 * staff privileges. Retaining them costs a couple of short-lived strings per
 * browser session and closes the race.
 *
 * Deliberately memory-only: these must never reach storage, where the phone
 * extension and cross-tab sync would pick them up.
 */
const impersonationBearers = new Set<string>();

export const rememberImpersonationToken = (token: string): void => {
  impersonationBearers.add(token);
};

/** Whether this Authorization header carries an impersonation bearer. */
export const isImpersonationAuthorization = (header: string): boolean => {
  const BEARER = "Bearer ";
  if (!header.startsWith(BEARER)) return false;
  return impersonationBearers.has(header.slice(BEARER.length));
};
